/** Visual tokens for /vysor-lab — polished agent chrome (Claude / Cursor inspired). */

const THEME_FONT =
  '"Inter", ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Helvetica", "Arial", sans-serif';

export const LAB = {
  fontDisplay: THEME_FONT,
  fontBody: THEME_FONT,
  column: 680,
  artifacts: 340,
  rail: 56,
  radius: {
    message: 20,
    composer: 24,
    chip: 14,
    panel: 18,
    starter: 16,
  },
  canvas: {
    light: '#fafafa',
    dark: '#0f0f0f',
  },
  surface: {
    light: '#ffffff',
    dark: '#1a1a1a',
  },
  ink: {
    light: '#0a0a0a',
    dark: '#f5f5f5',
  },
  muted: {
    light: '#737373',
    dark: '#a3a3a3',
  },
  userBubble: {
    light: '#f0f0f0',
    dark: '#262626',
  },
  hairline: {
    light: 'rgba(0, 0, 0, 0.08)',
    dark: 'rgba(255, 255, 255, 0.1)',
  },
  railBg: {
    light: '#f5f5f5',
    dark: '#141414',
  },
} as const;

export function labCanvas(mode: 'light' | 'dark') {
  return mode === 'dark' ? LAB.canvas.dark : LAB.canvas.light;
}
export function labSurface(mode: 'light' | 'dark') {
  return mode === 'dark' ? LAB.surface.dark : LAB.surface.light;
}
export function labInk(mode: 'light' | 'dark') {
  return mode === 'dark' ? LAB.ink.dark : LAB.ink.light;
}
export function labMuted(mode: 'light' | 'dark') {
  return mode === 'dark' ? LAB.muted.dark : LAB.muted.light;
}
export function labUserBubble(mode: 'light' | 'dark') {
  return mode === 'dark' ? LAB.userBubble.dark : LAB.userBubble.light;
}
export function labHairline(mode: 'light' | 'dark') {
  return mode === 'dark' ? LAB.hairline.dark : LAB.hairline.light;
}
export function labRailBg(mode: 'light' | 'dark') {
  return mode === 'dark' ? LAB.railBg.dark : LAB.railBg.light;
}

export const LAB_STARTERS: Array<{ id: string; label: string; description: string; prompt: string }> = [
  {
    id: 'start_configure_sso',
    label: 'Configure SSO',
    description: 'Connect an app to company login',
    prompt: 'I want to configure SSO',
  },
  {
    id: 'start_setup_app',
    label: 'Add an application',
    description: 'Register a new app in the catalog',
    prompt: 'I want to set up a new application',
  },
  {
    id: 'start_client_credentials',
    label: 'Machine-to-machine',
    description: 'Client ID & secret for API access',
    prompt: 'I need a client id and secret for machine-to-machine access',
  },
  {
    id: 'start_pending',
    label: 'Pending SSO',
    description: 'See what’s waiting for review',
    prompt: 'Show pending SSO requests',
  },
];
